var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"scroller",staticClass:"scroller scrollable",class:{ scrollX: _vm.scrollX, scrollY: _vm.scrollY },attrs:{"tabindex":""},on:{"scroll":_setup.handleScroll}},[_c('div',{ref:"content",staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }